import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getOccupationSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/occupationEvaluation/selectStudentSchemeList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  removeScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/delStudentScheme",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/selectSpecialityLibrary",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
    // return new Promise((resolve, reject) => {
    //   axios.post(`/occupationEvaluation/selectSpecialityLibrary`, params).then(response => {
    //     resolve(response);
    //   }).catch(error => {
    //     reject(error);
    //   });
    // });
  },
};
